import i18next from 'i18next'

const t = (key: string) => i18next.t(`editor:${key}`)

export const ADDITIONAL_QUESTION_TYPE_OPTIONS = [{
	id: 'select',
	render: (inList: boolean) => (
		<div className="px-3 py-1 bg-blue-50 text-blue-700">
			<span className="font-medium">{t('formBuilder.questionTypes.singleSelect')}</span>
			{inList && (
				<div className="text-xs pr-3 text-grey-500">
					{t('formBuilder.questionTypes.singleSelectDescription')}
				</div>
			)}
		</div>
	),
}, {
	id: 'select_multiple',
	render: (inList: boolean) => (
		<div className="px-3 py-1 bg-purple-50 text-purple-700">
			<span className="font-medium">{t('formBuilder.questionTypes.multiSelect')}</span>
			{inList && (
				<div className="text-xs pr-3 text-grey-500">
					{t('formBuilder.questionTypes.multiSelectDescription')}
				</div>
			)}
		</div>
	),
}, {
	id: 'open_text',
	render: (inList: boolean) => (
		<div className="px-3 py-1 bg-teal-50 text-teal-700">
			<span className="font-medium">{t('formBuilder.questionTypes.openText')}</span>
			{inList && (
				<div className="text-xs pr-3 text-grey-500">{t('formBuilder.questionTypes.openTextDescription')}</div>
			)}
		</div>
	),
}, {
	id: 'datetime',
	render: (inList: boolean) => (
		<div className="px-3 py-1 bg-amber-50 text-amber-700">
			<span className="font-medium">{t('formBuilder.questionTypes.date')}</span>
			{inList && (
				<div className="text-xs pr-3 text-grey-500">{t('formBuilder.questionTypes.dateDescription')}</div>
			)}
		</div>
	),
}, {
	id: 'file',
	render: (inList: boolean) => (
		<div className="px-3 py-1 bg-emerald-50 text-emerald-700">
			<span className="font-medium">{t('formBuilder.questionTypes.fileUpload')}</span>
			{inList && (
				<div className="text-xs pr-3 text-grey-500">{t('formBuilder.questionTypes.fileUploadDescription')}</div>
			)}
		</div>
	),
}] as const

export const TARGET_SCORE_RANGE_OPTIONS = [{
	id: 'excellent',
	labelKey: 'formBuilder.score.excellent' as const,
	className: 'bg-green-50 text-green-700 border-green-200',
}, {
	id: 'good',
	labelKey: 'formBuilder.score.good' as const,
	className: 'bg-lime-50 text-lime-700 border-lime-200',
}, {
	id: 'average',
	labelKey: 'formBuilder.score.average' as const,
	className: 'bg-yellow-50 text-yellow-700 border-yellow-200',
}] as const
